import React, { useState } from "react";
import { observer } from "mobx-react";
import { IAppStore } from "stores/Interfaces";
import { Upload, Button, Form } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { FieldConfig } from "components/common/forms/Interfaces";
import { acceptedTypes } from "components/tables/declarantTable/constants";

interface Props {
  defaultValue: string;
  store?: IAppStore;
  name: string;
  config?: FieldConfig;
}

const props = {
  name: "file",
  multiple: true,
};

const UploadFile: React.FC<Props> = ({
  store,
  defaultValue,
  name,
  config,
  ...rest
}) => {
  const [files, setFiles] = useState();

  const setFileValues = (selectedFiles: any) => {
    setFiles(selectedFiles.fileList);
  };

  return (
    <Form.Item
      name={name}
      label={config?.label}
      rules={config?.validationRules}
      labelCol={{ span: 24 }}
      style={{ marginBottom: 0 }}
      {...(config?.extra || {})}
      {...rest}
    >
      <Upload
        {...props}
        beforeUpload={() => false}
        onChange={(files) => setFileValues(files)}
        fileList={files}
        accept={acceptedTypes}
      >
        <Button
          icon={<UploadOutlined />}
          style={{
            height: 30,
            paddingLeft: "5px",
            paddingRight: "5px",
          }}
        >
          Upload
        </Button>
      </Upload>
    </Form.Item>
  );
};

export default observer(UploadFile);
